import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class AssetEventService extends Service {
	constructor(injector: Injector) {
		super("AssetEvent", injector);
	}

	// API	
	forAsset(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForAsset/${id}`);
	}

	forReporter(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForReporter/${id}`);
	}
}